import { FC, ReactNode } from "react";

import { Container, Stack } from "@mui/material";
import { Header } from "../Header/Header";

import { useLocation } from "react-router-dom";
import { MIN_CONTENT_WIDTH } from "../../constants/layout";
import { useAccountContext } from "../../strict/app/AccountResolver";
import { NavBar } from "../NavBar/NavBar";
import { DocumentHeadWrapper } from "../RouteHelpers";

interface AppLayoutProps {
  title: PageTitle;
  children: ReactNode;
}

export const AppLayout: FC<AppLayoutProps> = ({ title, children }) => {
  const { urlName } = useAccountContext();
  const location = useLocation();
  const isAdminPage = !urlName || !location.pathname.includes("/app/");
  return (
    <DocumentHeadWrapper title={title}>
      <Stack direction="row">
        {isAdminPage ? null : <NavBar />}
        <Stack sx={{ width: "100%", overflow: "auto", height: "100vh" }}>
          <Stack sx={{ height: "96px" }}>
            <Header />
          </Stack>
          <Stack
            sx={(theme) => ({
              height: "93vh",
              overflow: "auto",
              backgroundColor: theme.palette.surfaceLight20.main,
            })}
          >
            <Container
              sx={{
                mt: 4,
                mb: 4,
                minWidth: MIN_CONTENT_WIDTH,
              }}
              maxWidth={false}
            >
              {children}
            </Container>
          </Stack>
        </Stack>
      </Stack>
    </DocumentHeadWrapper>
  );
};
